import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  getValuesByIds,
  questionIpInitialValues,
  questionIpMandatoryFields,
  questionIpProperties,
  questionIpValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { CREATE_BATCH } from "utils/graphql/services/entities/mutations";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import LoadingButton from "@mui/lab/LoadingButton";
import { CREATE_COLLEGE_IP } from "utils/graphql/services/operations/mutations";
import { useEffect } from "react";
import { getCollegeFromStateId } from "utils/metadata-split/depedentApiFetch";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { setReactFormValues } from "utils/metadata-split/helper";
import { areArraysEqual } from "pages/configue/constants";

export const QuestionIPCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    questionIpInitialValues,
    questionIpValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const [createQuestionIp, { loading, error, data }] = useMutation(
    CREATE_COLLEGE_IP,
    {
      client: entitesClient,
    }
  );

  const updateMetaData = async (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    await dispatch(metadataSuccess(metadataList));
    if (metaKey == "college_list" && listData?.length == 0) {
      setValue("college_id", "");
    }
  };

  const handleCreateBatch = async () => {
    const collegeName = getValuesByIds(
      [watch()?.college_id],
      metaData?.college_list,
      "college_name",
      "college_id"
    );
    const stateName = getValuesByIds(
      [watch()?.state_id],
      metaData?.state_list,
      "state_name",
      "state_id"
    );
    try {
      const response: any = await createQuestionIp({
        variables: {
          input: {
            stateId: watch()?.state_id,
            stateName:stateName[0],
            collegeObjectId: watch()?.college_id,
            collegeName: collegeName[0],
            ipAddress: watch()?.ipAddress,
            status: watch()?.status,
            expiry: watch()?.expiry,
          },
        },
      });
      if (response?.data?.createCollegeIpAddress?.success) {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.createCollegeIpAddress?.message}` ||
              "Created QuestionIp successfully",
          })
        );
        history.replace(`/operations/question_ip`);
      } else if (!response?.data?.createCollegeIpAddress?.success) {
        dispatch(
          snackbarRequest({
            message: `${response?.data?.createCollegeIpAddress?.message}`,
            type: "error",
          })
        );
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.errorReason}`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(snackbarRequest({ message: `${err?.message}`, type: "error" }));
    }
  };

  useEffect(() => {
    (async () => {
      await getCollegeFromStateId(watch()?.state_id, updateMetaData);
    })();
  }, [watch()?.state_id]);

  useEffect(() => {
    if (metaData?.college_list?.length > 0 && !isLoad) {
      let matchedVales = setReactFormValues(
        metaData,
        "college_list",
        watch()?.college_id,
        "college_id"
      );
      let isEqual = areArraysEqual(watch()?.college_id, matchedVales);
      if (!isEqual) {
        setValue("college_id", matchedVales);
      }
    }
  }, [metaData?.college_list]);

  return (
    <div>
      <TypographyHeading>Create Branch IP Config</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={questionIpProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        </Grid>
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              loading={loading}
              sx={{
                width: "180px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateBatch}
              disabled={
                !isFieldsValidate(errors, questionIpMandatoryFields, getValues)
              }
            >
              Create Config
            </LoadingButton>
          </ContentRight>
      </Paper>
    </div>
  );
};
